import React from "react"
import "./sidebarNav.scss"
import { generatePath, Link, withRouter } from "react-router-dom"
import * as routes from "../../library/constants/routes"
import VerticalMenu from "../ui/verticalMenu/verticalMenu"
import { shallowEqual, useSelector } from "react-redux"
import { isDevMode } from "../../library/networking/API"
import { Divider } from "../v2/layout/forms/form/form"
import { howToArticles } from "../../screens/info/howTo/howToArticles"

const SidebarNav = (props) => {
  const {
    id: userId,
    deleted,
    blocked,
    role,
  } = useSelector(({ auth }) => auth.userData, shallowEqual)
  const { chatsCounter } = useSelector(
    ({ notifications }) => notifications,
    shallowEqual
  )
  const menuItems = [
    // {
    //   path: routes.HOME,
    //   label: "Calendar",
    // },
    // {
    //   path: routes.CALENDAR,
    //   label: "Calendar",
    // },
    role !== 4 && {
      // path: routes.KNOWMAP_MEETS,
      path: routes.KNOWMAP_INCOMING_APPOINTMENT_BOOKINGS,
      label: "Tracking",
    },
    {
      path: generatePath(routes.KNOWMIX_LIST, { userId }),
      label: "Courses",
    },
    // {
    //   path: generatePath(routes.KNOWCRED, { userId }),
    //   label: "Cred",
    // },
    // {
    //   path: generatePath(routes.GROUPS, { userId }),
    //   label: "Groups",
    // },
    // {
    //   path: routes.BOOKMARKS,
    //   label: "Bookmarks",
    // },
    {
      path: generatePath(routes.INVENSTORY, { userId }),
      label: "InvenStory",
    },

    {
      type: "h-divider",
      id: "hd1",
    },
    {
      path: routes.MARKETPLACE,
      label: "Featured Products",
    },
    {
      path: routes.STANDARDS,
      label: "Standards",
    },
  ].filter(Boolean)

  return (
    <>
      {!deleted && !blocked && <VerticalMenu menuItems={menuItems} />}
      <ul className="menu menu--simple">
        <li className="menu__item">
          <Link to={routes.PRICING} className="link menu__link--simple">
            Pricing
          </Link>
        </li>
        <li className="menu__item">
          <Link
            to={generatePath(routes.HOW_TO, {
              articleId: howToArticles[0].slug,
            })}
            className="link menu__link--simple"
          >
            How to
          </Link>
        </li>
        {/*<li className="menu__item">*/}
        {/*  <Link to={routes.UKNOW_INFO} className="link menu__link--simple">*/}
        {/*    About Knowmeet*/}
        {/*  </Link>*/}
        {/*</li>*/}
        {/*<li className="menu__item">*/}
        {/*  <Link to={routes.PRICING} className="link menu__link--simple">*/}
        {/*    Pricing*/}
        {/*  </Link>*/}
        {/*</li>*/}
        {/*<li className="menu__item">*/}
        {/*  <Link to={routes.ABOUT_US} className="link menu__link--simple">*/}
        {/*    About Us*/}
        {/*  </Link>*/}
        {/*</li>*/}
        <li className="menu__item">
          <Link to={routes.ACCOUNTS_INFO} className="link menu__link--simple">
            Info
          </Link>
        </li>
        <li className="menu__item">
          <Link to={routes.CONTACT_FORM} className="link menu__link--simple">
            Contact Us
          </Link>
        </li>
        <li className="menu__item">
          <Link
            to={routes.TERMS_AND_CONDITIONS}
            className="link menu__link--simple"
          >
            Terms and Conditions
          </Link>
        </li>
        <li className="menu__item">
          <Link to={routes.APP_PROMOTE} className="link menu__link--simple">
            App
          </Link>
        </li>
      </ul>

      {isDevMode && <FastDevLinks />}
    </>
  )
}

const FastDevLinks = () => (
  <>
    <Divider />
    <ul className="menu menu--simple">
      <li className="menu__item">
        <Link
          to={generatePath(routes.GROUP, { groupId: 143861 })}
          className="link menu__link--simple"
        >
          One Teacher School
        </Link>
      </li>
      <li className="menu__item">
        <Link
          to={generatePath(routes.GROUP, { groupId: 143850 })}
          className="link menu__link--simple"
        >
          School
        </Link>
      </li>
      <li className="menu__item">
        <Link
          to={generatePath(routes.GROUP, { groupId: 23943 })}
          className="link menu__link--simple"
        >
          District
        </Link>
      </li>
    </ul>
  </>
)

export default withRouter(SidebarNav)
